"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgScuba = function SvgScuba(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.546 6.622a.288.288 0 0 1-.135.308 9.052 9.052 0 0 0-4.497 7.557.317.317 0 0 1-.275.293c-.46.07-.861.332-.861.886v2.15c0 .554.4.817.861.887.149.023.27.141.27.291v1.653c0 .5.407.906.907.906H20.12c.5 0 .906-.406.906-.906v-1.653c0-.15.123-.27.27-.291.461-.07.862-.333.862-.887v-2.15c0-.554-.401-.817-.861-.886a.316.316 0 0 1-.275-.293 9.056 9.056 0 0 0-4.497-7.557.29.29 0 0 1-.135-.308 4.51 4.51 0 1 0-8.842 0Zm6.37-.71c.16.035.32-.074.316-.238-.031-1.195-1.033-2.22-2.265-2.22-1.233 0-2.234 1.025-2.265 2.22-.004.165.155.274.317.238a9.077 9.077 0 0 1 1.948-.21c.67 0 1.321.074 1.95.211h-.002Zm4.742 11.192c-.388 1.43-1.6 2.192-2.795 2.184-.811-.006-1.923-.238-2.529-.997a4.401 4.401 0 0 1-.248-.352c-.052-.078-.103-.156-.158-.232a1.208 1.208 0 0 0-.96-.528 1.2 1.2 0 0 0-.96.528c-.055.076-.106.154-.158.232-.08.12-.16.24-.249.352-.606.758-1.718.991-2.528.997-1.195.009-2.408-.752-2.795-2.184-.552-2.036 1.094-4.724 6.666-4.74h.048c5.572.016 7.219 2.704 6.667 4.74h-.001Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgScuba);
var _default = exports["default"] = Memo;